import React from "react";
import Paper from "material-ui/Paper";
import Button from "material-ui/Button";
import Select from "material-ui/Select";
import Input from "material-ui/Input";
import { MenuItem } from "material-ui/Menu";
import { withStyles } from "material-ui/styles";
import isMobile from "ismobilejs";
import { isAnswer } from "utils/formatter";
import history from "utils/history";
import Dialog, {
  DialogActions,
  DialogContent
} from "material-ui/Dialog";
import Typography from "material-ui/Typography";

const browserStyles = theme => ({
  container: {
    margin: 20,
    padding: 20,
    backgroundColor: theme.palette.answer.backgroundColor,
    height: 570,
    position: "relative"
  },
  surveyNameWrapper: {
    margin: "20px 40px"
  },
  surveyName: {
    fontSize: "1.6rem",
    borderBottom: `5px solid ${theme.palette.answer.borderColor}`,
    padding: "3px 20px"
  },
  description: {
    border: `10px solid ${theme.palette.answer.borderColor}`,
    backgroundColor: "white",
    margin: 40,
    padding: 10,
    whiteSpace: "pre-wrap",
    wordBreak: "break-word"
  },
  itemsDiv: {
    display: "flex",
    margin: "100px 40px 0"
  },
  localeWrapper: {
    flex: 1,
    textAlign: "right"
  },
  localeLabel: {
    marginRight: 20
  },
  startBtnWrapper: {
    flex: 1,
    textAlign: "center"
  },
  spacer: {
    flex: 1
  },
  footer: {
    position: "absolute",
    bottom: 0,
    width: "100%",
    margin: "0 -40px 10px",
    textAlign: "right"
  }
});

const mobileStyles = theme => ({
  container: {
    margin: 10,
    padding: 10,
    backgroundColor: theme.palette.answer.backgroundColor
  },
  surveyNameWrapper: {
    marginBottom: 20
  },
  surveyName: {
    borderBottom: `2px solid ${theme.palette.answer.borderColor}`,
    padding: "3px 5px"
  },
  description: {
    border: `2px solid ${theme.palette.answer.borderColor}`,
    backgroundColor: "white",
    margin: 2,
    padding: "10px 15px",
    whiteSpace: "pre-wrap",
    wordBreak: "break-word"
  },
  localeWrapper: {
    display: "block",
    margin: "20px 20px 50px"
  },
  localeLabel: {
    marginRight: 10
  },
  startBtnWrapper: {
    margin: 20,
    textAlign: "center"
  },
  footer: {
    fontSize: ".8rem",
    textAlign: "right"
  }
});

class AnswerStart extends React.Component {
  state = {
    reopenDialog: false,
  };

  openReopenDialog = () => {
    this.setState({ reopenDialog: true });
  };

  closeReopenDialog = () => {
    this.setState({ reopenDialog: false });
  };
  componentWillMount() {
    const { answerToken } = this.props.answerHeader;
    const { localeId } = this.props.answerResult;
    const { urlToken } = this.props.match.params;
    const { surveyId } = this.props.match.params;

    const isPreview = !isAnswer();
    if (isPreview || answerToken) {
      if (isPreview) {
        this.props.fetchAnswerStart(answerToken, localeId, urlToken, surveyId);
      } else {
        this.props
          .fetchAnswerStart(answerToken, localeId, urlToken, surveyId)
          .then((res) => {
            if (res.permanentSave) {
              const { localeId } = res.permanentSavedState.surveyResult;
              const { answerToken } = this.props.answerHeader;

              if (answerToken) {
                this.props.fetchAttributeReady(
                  answerToken,
                  localeId,
                  null,
                  null,
                  null,
                  res.permanentSave,
                  res.permanentSavedState
                );
                history.push('/result', this.props);

                if (isAnswer()) {
                  window.addEventListener('beforeunload', this.showReloadAlert);
                }
              } else {
                // answerTokenなしは認証エラー
                this.props.showErrorDialog();
              }
            }
          });
      }
      if (isAnswer()) {
        window.addEventListener('beforeunload', this.showReloadAlert);
        window.addEventListener('popstate', this.popStateListener, false);
      }
    } else {
      // answerTokenなしは認証エラー
      this.props.showErrorDialog();
    }
  }

  componentDidMount() {
    window.history.replaceState(null, '', window.location.pathname);
    window.history.pushState(null, '', window.location.pathname);
    window.addEventListener('popstate', this.popStateListener);
    window.addEventListener('beforeunload', this.showReloadAlert);
  }

  componentWillUnmount() {
    if (isAnswer()) {
      window.removeEventListener('popstate', this.popStateListener);
      window.removeEventListener('beforeunload', this.showReloadAlert);
    }
  }

  popStateListener = () => {
    if (window.location.pathname === '/answer/start') {
      window.history.pushState(null, '', window.location.pathname);
      window.location.pathname = `answer/login/survey/${localStorage.getItem(
        'urlToken'
      )}`;
    }
  };

  showReloadAlert(e) {
    e.returnValue = '回答は削除されます。';
  }

  fetchAttributeReady = () => {
    const { answerToken } = this.props.answerHeader;
    const { locale, additionResult } = this.props.answerResult;
    const { tempSavedPath, tempSavedBasicResult, tempSavedAttrResult } = this.props.answerStart;

    if (answerToken) {
      const attributePage = Object.keys(tempSavedAttrResult).length;
      const tempSavedAdditionalResult = Object.keys(additionResult).length;
      const tempSavedPage = Object.keys(tempSavedBasicResult).length + (Object.keys(tempSavedBasicResult).length ? (1 + tempSavedAdditionalResult) : 0);
      const currentSavedPage = (tempSavedPath === "/answer_question" && tempSavedPage === 0 ) ? 1  : (tempSavedPage || attributePage);
      this.props.fetchAttributeReady(
        answerToken,
        locale.id,
        currentSavedPage,
        tempSavedPath,
        attributePage
      );
      if (tempSavedPath === '/answer_question') {
        history.push('/attribute_ready', this.props);
        history.push('/answer_attribute', this.props);
        history.push('/question_ready', this.props);
      }
      history.push(tempSavedPath, this.props);

      if (isAnswer()) {
        window.addEventListener('beforeunload', this.showReloadAlert);
      }
    } else {
      // answerTokenなしは認証エラー
      this.props.showErrorDialog();
    }
  };

  render() {
    const { classes, answerStart, answerHeader } = this.props;
    const { surveyLocale, surveyLocales, isTemporarySaved } = answerStart; // state
    const { isEffecting } = answerHeader;

    const { changeLocale, handleStart, clearTemporarySaved } = this.props; // action

    return (
      <div>
        <Dialog
          open={this.state.reopenDialog}
          onClose={this.closeReopenDialog}
          PaperProps={{
            style: {
              padding: '30px',
              borderRadius: '8px',
            },
          }}
        >
          <DialogContent
            style={{
              marginTop: '10px',
              textAlign: 'center',
              borderBottom: 'none',
            }}
          >
            <Typography
              variant='body1'
              style={{ fontSize: '1.8rem', lineHeight: '2.8rem' }}
            >
              回答中のデータがあります。
              <br />
              再開しますか？
            </Typography>
          </DialogContent>

          <DialogActions
            style={{
              justifyContent: 'space-between',
              padding: '30px 40px 10px',
            }}
          >
            <Button
              raised
              onClick={() => {
                this.fetchAttributeReady();
                this.closeReopenDialog();
              }}
              style={{
                minWidth: 140,
                fontSize: '1.4rem',
              }}
            >
              再開する
            </Button>

            <Button
              raised
              onClick={() => {
                if (!isEffecting) {
                  clearTemporarySaved();
                  handleStart(surveyLocale.locale.id);
                }
              }}
              style={{
                minWidth: 140,
                fontSize: '1.4rem',
              }}
            >
              最初から
            </Button>
          </DialogActions>
        </Dialog>

        <Paper className={classes.container}>
          <div className={classes.surveyNameWrapper}>
            <span className={classes.surveyName}>
              {surveyLocale.surveyName}
            </span>
          </div>

          <div className={classes.description}>{surveyLocale.description}</div>

          <div className={classes.itemsDiv}>
            <span className={classes.localeWrapper}>
              <span className={classes.localeLabel}>言語/Language</span>
              {surveyLocale.id && (
                <Select
                  value={surveyLocale.locale.id}
                  onChange={(e) => changeLocale(e.target.value)}
                  input={<Input name='select-locale' id='select-locale' />}
                >
                  {surveyLocales.map((sl) => (
                    <MenuItem key={sl.id} value={sl.locale.id}>
                      {sl.locale.nativeLabel}
                    </MenuItem>
                  ))}
                </Select>
              )}
            </span>

            <div className={classes.startBtnWrapper}>
              <Button
                raised
                onClick={() => {
                  if (isTemporarySaved) {
                    // show dialog
                    this.openReopenDialog();
                  } else {
                    if (!isEffecting) {
                      handleStart(surveyLocale.locale.id);
                    }
                  }
                }}
              >
                はじめる
              </Button>
            </div>

            <div className={classes.spacer} />
          </div>
          <div className={classes.footer}>
            （公財）日本生産性本部 コンサルティング部
          </div>
        </Paper>
      </div>
    );
  }
}

export default withStyles(isMobile.any ? mobileStyles : browserStyles)(
  AnswerStart
);



// WEBPACK FOOTER //
// ./src/components/answer/AnswerStart.jsx